class ModelDevelopmentProjectDetails {
    constructor(name, description) {
        this.name = name;
        this.description = description;
    }
}

export default ModelDevelopmentProjectDetails;
